(()=>{
  const wrap=document.querySelector('[data-klx-search]');
  if(!wrap||wrap.dataset.klxSearchReady==='true')return;

  const form=wrap.querySelector('form');
  const input=wrap.querySelector('[data-klx-search-input]');
  const panel=wrap.querySelector('[data-klx-search-results]');
  if(!form||!input||!panel)return;

  wrap.dataset.klxSearchReady='true';
  let debounceTimer=0;
  let controller=null;
  let lastTerm='';

  const money=value=>{
    const amount=Number(value);
    if(!Number.isFinite(amount))return '';
    try{return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(amount)}catch(e){return `₹${Math.round(amount).toLocaleString('en-IN')}`}
  };

  const searchUrlFor=term=>{
    const url=new URL(form.action,window.location.origin);
    url.searchParams.set('q',term);
    url.searchParams.set('type','product');
    url.searchParams.set('options[prefix]','last');
    return url.toString();
  };

  const setOpen=open=>{
    panel.hidden=!open;
    input.setAttribute('aria-expanded',String(open));
  };

  const clearPanel=()=>{
    panel.replaceChildren();
    setOpen(false);
  };

  const addMessage=text=>{
    const message=document.createElement('div');
    message.className='klx-search-suggest__message';
    message.textContent=text;
    panel.appendChild(message);
  };

  const addGroupLabel=text=>{
    const label=document.createElement('div');
    label.className='klx-search-suggest__label';
    label.textContent=text;
    panel.appendChild(label);
  };

  const addProduct=product=>{
    const link=document.createElement('a');
    link.className='klx-search-suggest__product';
    link.dataset.klxSuggestLink='';
    link.setAttribute('role','option');
    link.href=product.url||searchUrlFor(product.title||'');

    const media=document.createElement('span');
    media.className='klx-search-suggest__media';
    const imageUrl=product.featured_image&&product.featured_image.url?product.featured_image.url:(typeof product.featured_image==='string'?product.featured_image:'');
    if(imageUrl){
      const img=document.createElement('img');
      img.src=imageUrl;
      img.alt='';
      img.loading='lazy';
      img.width=58;
      img.height=58;
      media.appendChild(img);
    }else{
      media.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v14H4zM7 15l3-3 2.5 2.5L15 12l3 3"/></svg>';
    }

    const copy=document.createElement('span');
    copy.className='klx-search-suggest__copy';
    const title=document.createElement('strong');
    title.textContent=product.title||'Product';
    copy.appendChild(title);
    const price=money(product.price);
    if(price){
      const priceEl=document.createElement('span');
      priceEl.className='klx-search-suggest__price';
      priceEl.textContent=price;
      copy.appendChild(priceEl);
    }

    const arrow=document.createElement('span');
    arrow.className='klx-search-suggest__arrow';
    arrow.setAttribute('aria-hidden','true');
    arrow.textContent='→';
    link.append(media,copy,arrow);
    panel.appendChild(link);
  };

  const render=(data,term)=>{
    if(input.value.trim()!==term)return;
    panel.replaceChildren();
    const results=data&&data.resources&&data.resources.results?data.resources.results:{};
    const products=Array.isArray(results.products)?results.products.slice(0,6):[];
    const queries=Array.isArray(results.queries)?results.queries.slice(0,3):[];

    if(products.length){
      addGroupLabel('Products');
      products.forEach(addProduct);
    }
    if(queries.length){
      addGroupLabel('Search suggestions');
      const queryWrap=document.createElement('div');
      queryWrap.className='klx-search-suggest__queries';
      panel.appendChild(queryWrap);
      queries.forEach(query=>{
        const text=(query&&query.text?query.text:String(query||'')).trim();
        if(!text)return;
        const link=document.createElement('a');
        link.className='klx-search-suggest__query';
        link.dataset.klxSuggestLink='';
        link.setAttribute('role','option');
        link.href=searchUrlFor(text);
        link.textContent=text;
        queryWrap.appendChild(link);
      });
    }

    if(!products.length&&!queries.length)addMessage('No matching products yet. Press Enter to search.');

    const all=document.createElement('a');
    all.className='klx-search-suggest__all';
    all.dataset.klxSuggestLink='';
    all.href=searchUrlFor(term);
    all.innerHTML='<span>View all results</span><strong>→</strong>';
    panel.appendChild(all);
    setOpen(true);
  };

  const fetchSuggestions=async term=>{
    if(controller)controller.abort();
    controller=new AbortController();
    lastTerm=term;
    panel.replaceChildren();
    addMessage('Searching…');
    setOpen(true);

    try{
      let root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      if(!root.endsWith('/'))root+='/';
      const url=new URL(`${root}search/suggest.json`,window.location.origin);
      url.searchParams.set('q',term);
      url.searchParams.set('resources[type]','product,query');
      url.searchParams.set('resources[limit]','6');
      url.searchParams.set('resources[options][unavailable_products]','last');
      const response=await fetch(url.toString(),{headers:{Accept:'application/json'},signal:controller.signal});
      if(!response.ok)throw new Error(`Search request failed: ${response.status}`);
      const data=await response.json();
      render(data,term);
    }catch(error){
      if(error&&error.name==='AbortError')return;
      if(input.value.trim()!==term)return;
      panel.replaceChildren();
      addMessage('Keep typing or press Enter to search.');
      setOpen(true);
    }
  };

  const schedule=()=>{
    window.clearTimeout(debounceTimer);
    const term=input.value.trim();
    if(term.length<2){
      if(controller)controller.abort();
      lastTerm='';
      clearPanel();
      return;
    }
    debounceTimer=window.setTimeout(()=>fetchSuggestions(term),220);
  };

  input.addEventListener('input',schedule);
  input.addEventListener('focus',()=>{
    const term=input.value.trim();
    if(term.length<2)return;
    if(term===lastTerm&&panel.childElementCount){setOpen(true);return;}
    schedule();
  });

  input.addEventListener('keydown',event=>{
    if(event.key==='ArrowDown'&&!panel.hidden){
      const first=panel.querySelector('[data-klx-suggest-link]');
      if(first){event.preventDefault();first.focus();}
    }else if(event.key==='Escape'){
      setOpen(false);
    }
  });

  panel.addEventListener('keydown',event=>{
    const links=[...panel.querySelectorAll('[data-klx-suggest-link]')];
    if(!links.length)return;
    const index=links.indexOf(document.activeElement);
    if(event.key==='ArrowDown'){
      event.preventDefault();
      links[(index+1+links.length)%links.length].focus();
    }else if(event.key==='ArrowUp'){
      event.preventDefault();
      if(index<=0)input.focus();else links[index-1].focus();
    }else if(event.key==='Escape'){
      event.preventDefault();
      setOpen(false);
      input.focus();
    }
  });

  document.addEventListener('pointerdown',event=>{
    if(!wrap.contains(event.target))setOpen(false);
  });
})();

/* Mobile menu QA fix: keep the existing design and make the drawer reliably closable. */
(()=>{
  const header=document.querySelector('[data-klx-header]');
  const toggle=document.querySelector('[data-klx-mobile-toggle]');
  if(!header||!toggle||header.dataset.klxMobileMenuFix==='true')return;
  header.dataset.klxMobileMenuFix='true';

  const iconPath=toggle.querySelector('svg path');
  const originalPath=iconPath?iconPath.getAttribute('d'):'';
  const searchPanel=document.querySelector('[data-klx-search-results]');
  const searchInput=document.querySelector('[data-klx-search-input]');

  const sync=()=>{
    const open=header.classList.contains('is-menu-open');
    toggle.setAttribute('aria-expanded',String(open));
    toggle.setAttribute('aria-label',open?'Close menu':'Open menu');
    if(iconPath){
      if(open)iconPath.setAttribute('d','M6 6l12 12M18 6 6 18');
      else if(originalPath)iconPath.setAttribute('d',originalPath);
    }
    if(open&&searchPanel){
      searchPanel.hidden=true;
      if(searchInput)searchInput.setAttribute('aria-expanded','false');
    }
  };

  const closeMenu=()=>{
    if(!header.classList.contains('is-menu-open'))return;
    header.classList.remove('is-menu-open');
    sync();
  };

  new MutationObserver(sync).observe(header,{attributes:true,attributeFilter:['class']});

  document.addEventListener('pointerdown',event=>{
    if(window.innerWidth>840||!header.classList.contains('is-menu-open'))return;
    if(event.target.closest('.klx-nav-wrap')||event.target.closest('[data-klx-mobile-toggle]'))return;
    closeMenu();
  },{passive:true});

  window.addEventListener('resize',()=>{
    if(window.innerWidth>840)closeMenu();
  },{passive:true});

  sync();
})();
